<!--
 * @Author: 张定勇 1721091954@qq.com
 * @Date: 2023-11-01 17:24:34
 * @LastEditors: 张定勇 1721091954@qq.com
 * @LastEditTime: 2023-11-07 14:00:11
 * @FilePath: /dqym/src/views/components/mapInfos.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="mapInfo father-module flex flex-v">
    <div class="title-module">
      <img src="@/assets/image/layout/mod-title.png" alt="" class="title-module-img" />
      设施详情
    </div>
    <div class="flex-1 mod-bd">
      <div>桥梁名称：{{ infowData.bridgeName }}</div>
      <div>
        桥梁简介：
        <span v-html="infowData.introduce" v-if="infowData.introduce"> </span>
        <span v-else>暂无介绍</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelMapInfo',
  props: ['infowData'],
  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.mapInfo {
  width: 600px;
  // height: 351px;
  // background: rgba(25, 58, 127, 0.8);
  // border-radius: 10px;
  // border: 1px solid #33b4f0;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  .mod-bd {
    padding: 20px;
  }
}
</style>
